import type { FilterDefinition } from '@cognite/sdk';

export const buildSpaceFilter = (
  spaces?: string[]
): FilterDefinition | undefined => {
  if (!spaces?.length) {
    return undefined;
  }

  return {
    in: {
      property: ['node', 'space'],
      values: spaces,
    },
  };
};

export const combineSearchFilters = (
  ...filters: (FilterDefinition | undefined)[]
): FilterDefinition | undefined => {
  const defined = filters.filter(
    (filter): filter is FilterDefinition => filter !== undefined
  );

  if (defined.length === 0) {
    return undefined;
  }

  if (defined.length === 1) {
    return defined[0];
  }

  return { and: defined };
};

export const encodeDirectRelationFilterValue = (ref: {
  externalId: string;
  space: string;
}): string => `${ref.space}::${ref.externalId}`;
